import React, { useRef, useReducer } from "react";
import { Grid, Input, Button, InputLabel } from "@mui/material";
import AddIcon from "@mui/icons-material/Add";
import PropTypes from "prop-types";
import { AddUserFormReducer } from "reducers/formReducers";
import tagAdminConstants from "constants/tagAdminConstants";

const initialValue = {
  user: {
    email: "",
    first_name: "",
    last_name: "",
    username: "",
  },
  userprofile: {
    organization: "",
    roles: [1, 2],
  },
};

function AddUserForm({ handleResponse, orgId }) {
  const [formState, dispatch] = useReducer(AddUserFormReducer, initialValue);
  const hiddenFileInput = useRef(null);
  const { email, first_name, last_name, username, errors, userImage } =
    formState;
  const onChange = (e) => {
    dispatch({
      type: e.target.name,
      payload: {
        field: e.target.name,
        value: e.target.value,
      },
    });
  };

  const handleClick = () => {
    hiddenFileInput.current.click();
  };
  const imageValidation = (imagetype) => {
    let validImageType = false;
    const imagetypeValid = imagetype.name.match(
      tagAdminConstants.UPLOAD_IMAGE_PATTERN_REGEX
    );
    if (!imagetypeValid) {
      validImageType = true;
    }
    return validImageType;
  };
  const handleChange = (event) => {
    const fileUploaded = event.target.files[0];
    const checkValidImage = imageValidation(fileUploaded);
    if (checkValidImage) {
      const issues = {};
      issues.userImage = "*Please select valid image.";
      dispatch({
        type: "validation",
        payload: {
          issues,
        },
      });
      return;
    }
    dispatch({
      type: "userImage",
      payload: {
        userImage: fileUploaded,
      },
    });
    const reader = new FileReader();
    reader.onload = () => {
      const dataURL = reader.result;
      const output = document.getElementById("organizationImageOutput");
      output.src = dataURL;
    };
    reader.readAsDataURL(event.target.files[0]);
  };
  // validation function
  const validateForm = () => {
    let formIsValid = true;
    const issues = {};
    if (!email) {
      formIsValid = false;
      issues.email = "*Please enter organization email.";
    } else if (typeof email !== "undefined") {
      // regular expression for email validation
      const pattern = tagAdminConstants.EMAIL_PATTERN_REGEX;
      if (!pattern.test(email)) {
        formIsValid = false;
        issues.email = "*Please enter valid email.";
      }
    }

    if (!last_name) {
      formIsValid = false;
      issues.last_name = "*Please enter Last Name.";
    }
    if (!first_name) {
      formIsValid = false;
      issues.first_name = "*Please enter First Name.";
    }
    if (!userImage) {
      formIsValid = false;
      issues.userImage = "*Please select user image.";
    }
    if (
      userImage &&
      !userImage.name.match(tagAdminConstants.UPLOAD_IMAGE_PATTERN_REGEX)
    ) {
      formIsValid = false;
      issues.validUserImage = "*Please select valid image.";
    }
    dispatch({
      type: "validation",
      payload: {
        issues,
      },
    });
    return formIsValid;
  };

  const addNewUser = (e) => {
    e.preventDefault();
    if (validateForm()) {
      handleResponse({ email, first_name, last_name, username, userImage });
    }
  };
  const errorMessage = errors?.issues;

  return (
    <form className="b-modal-container" onSubmit={addNewUser}>
      <Grid container spacing={4} className="b-modal-container__form">
        <Grid item md={3.5} xs={12}>
          {userImage == null ? (
            <>
              <button
                className="b-modal-container__button-logo"
                type="button"
                onClick={(event) => handleClick(event)}
              >
                Upload Profile Image
              </button>

              <input
                className="b-organization-container__file"
                type="file"
                ref={hiddenFileInput}
                onChange={handleChange}
                accept="image/*"
              />
              {errorMessage && errorMessage.userImage !== undefined && (
                <div className="errorMsg">{errorMessage.userImage}</div>
              )}
            </>
          ) : (
            <>
              <button
                type="button"
                onClick={(event) => handleClick(event)}
                className="b-modal-container__button-logo"
              >
                <img
                  alt=""
                  id="organizationImageOutput"
                  style={{
                    width: "100%",
                    height: "100%",
                    objectFit: "cover",
                    margin: "none",
                  }}
                />
              </button>

              <input
                className="b-organization-container__file"
                type="file"
                ref={hiddenFileInput}
                onChange={handleChange}
                accept="image/*"
              />
              {errorMessage && errorMessage.validUserImage !== undefined && (
                <span className="errorMsg">{errorMessage.validUserImage}</span>
              )}
            </>
          )}
        </Grid>
        <Grid item md={8.5} xs={12}>
          <InputLabel
            htmlFor="first_name"
            className="font-bold  b-organization-container__label"
          >
            First Name
          </InputLabel>

          <Input
            id="first_name"
            className="dafault-font-family b-organization-container__input"
            value={first_name}
            name="first_name"
            variant="standard"
            onChange={onChange}
          />
          {errorMessage && errorMessage.first_name !== "" && (
            <div className="errorMsg">{errorMessage.first_name}</div>
          )}
          <div className="b-organization-container__detailHead">
            <InputLabel
              htmlFor="last_name"
              className="font-bold b-organization-container__companyLabel"
            >
              Last Name
            </InputLabel>

            <Input
              id="last_name"
              className="dafault-font-family b-organization-container__companyname"
              value={last_name}
              name="last_name"
              variant="standard"
              onChange={onChange}
            />
            {errorMessage && errorMessage.last_name !== "" && (
              <span className="errorMsg">{errorMessage.last_name}</span>
            )}
          </div>
          <div className="b-organization-container__label-div">
            <InputLabel
              htmlFor="email"
              className="font-bold  b-organization-container__label"
            >
              Primary Email
            </InputLabel>
            <Input
              id="email"
              className="dafault-font-family b-organization-container__input"
              value={email}
              name="email"
              variant="standard"
              onChange={onChange}
            />
            {errorMessage && errorMessage.email !== "" && (
              <span className="errorMsg">{errorMessage.email}</span>
            )}
          </div>
          <Input type="hidden" name="orgId" value={orgId} />
          <div className="b-organization-container__buttonHead padding-bottom">
            <Button
              type="submit"
              className="b-btn-container__btn-add-new"
              variant="outlined"
            >
              <AddIcon /> Add New User
            </Button>
          </div>
        </Grid>
      </Grid>
    </form>
  );
}
AddUserForm.propTypes = {
  handleResponse: PropTypes.func.isRequired,
  orgId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
};

export default AddUserForm;
